import classNames from 'clsx'
import { bool, node, string } from 'prop-types'

import Button from 'views/components/atoms/Button'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import { buttonTypes } from 'views/utils/propTypes/buttonTypes'

import './ButtonBlockMenu.scss'

const ButtonBlockMenu = props => {
  const { children, hasChildren, secondary, ghost, light, ...rest } = props
  const buttonClassnames = classNames('a-Button--BlockMenu', {
    'a-Button--BlockMenu-secondary': secondary,
    'a-Button--BlockMenu-light': light,
    'a-Button--BlockMenu-ghost': ghost,
  })

  return (
    <Button {...rest} className={buttonClassnames}>
      {children}
      {hasChildren && <IconCaretRight />}
    </Button>
  )
}

ButtonBlockMenu.propTypes = {
  children: node.isRequired,
  href: string,
  hasChildren: bool,
  secondary: bool,
  light: bool,
  ghost: bool,
  type: buttonTypes,
}

ButtonBlockMenu.defaultProps = {
  href: null,
  hasChildren: false,
  secondary: false,
  light: false,
  ghost: false,
  type: null,
}

export default ButtonBlockMenu
